import { NfpLogo } from "@/components/Brand";
import { Mail } from "lucide-react";

const PRIVACY_URL = "https://sites.google.com/view/nfpprivacypolicy/home";
const TERMS_URL = "https://www.apple.com/legal/internet-services/itunes/dev/stdeula/";
const SUPPORT_URL = "https://sites.google.com/view/nfp-support/home";
const SUPPORT_EMAIL = "Tray@nofatiguetraining.net";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#070707]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <NfpLogo />
          <p className="mt-5 text-white/60 max-w-sm leading-relaxed">
            NFP — Nofatigue Programming. Train smarter. Perform better.
            Structured sport-performance and fitness training for athletes and
            everyday users.
          </p>
          <p className="mt-3 text-white/40 text-xs max-w-sm leading-relaxed">
            Built by a Sports Scientist and Exercise Physiologist. Refined by elite coaches and sports scientists.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="mt-6 inline-flex items-center gap-2 text-white/70 hover:text-white text-sm"
            data-testid="footer-support-email"
          >
            <Mail className="w-4 h-4" />
            {SUPPORT_EMAIL}
          </a>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white/40 text-xs tracking-[0.2em] uppercase mb-4">Product</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="/#programs" className="text-white/75 hover:text-white">Programs</a></li>
            <li><a href="/#features" className="text-white/75 hover:text-white">Features</a></li>
            <li><a href="/#pricing" className="text-white/75 hover:text-white">Pricing</a></li>
            <li><a href="/#fatigue-score" className="text-white/75 hover:text-white">No Fatigue Score</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-white/40 text-xs tracking-[0.2em] uppercase mb-4">Company</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={SUPPORT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/75 hover:text-white"
                data-testid="footer-link-support"
              >
                Support
              </a>
            </li>
            <li>
              <a href={`mailto:${SUPPORT_EMAIL}`} className="text-white/75 hover:text-white">
                Contact
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-white/40 text-xs tracking-[0.2em] uppercase mb-4">Legal</h4>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                href={PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/75 hover:text-white"
                data-testid="footer-link-privacy"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href={TERMS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/75 hover:text-white"
                data-testid="footer-link-terms"
              >
                Terms of Use (EULA)
              </a>
            </li>
            <li>
              <a href="#pricing" className="text-white/75 hover:text-white">Subscription Info</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="text-xs text-white/40 tracking-wide">
            © 2026 Nofatigue Programming. All rights reserved.
          </p>
          <p className="text-xs text-white/40 tracking-wide max-w-2xl">
            NFP subscriptions are managed through Apple In-App Purchase. Manage
            or cancel anytime in your Apple ID subscription settings.
          </p>
        </div>
      </div>
    </footer>
  );
}
